"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectCurrentInitiativeId = void 0;
const effects_1 = require("redux-saga/effects");
const selectCurrentInitiativeId = () => (0, effects_1.select)((state) => { var _a; return (_a = state.core.initiatives.byId.get.data) === null || _a === void 0 ? void 0 : _a.id; });
exports.selectCurrentInitiativeId = selectCurrentInitiativeId;
//# sourceMappingURL=selectors.js.map